import React from "react";
import clsx from "clsx";
import Axios from "axios";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import MoreIcon from "@material-ui/icons/More";
import { menuOptions } from "../../models/menuOptions";
import MenuItem from "./MenuItem";
import fileSaver from "file-saver";
import Menu from "@material-ui/core/Menu";
import PopMenuItem from "@material-ui/core/MenuItem";
import StorefrontIcon from "@material-ui/icons/Storefront";
import EqualizerIcon from "@material-ui/icons/Equalizer";
import ContactSupportIcon from "@material-ui/icons/ContactSupport";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { combineProps } from "../../../../helpers/objectHelper";
import { Avatar, ListItem, ListItemAvatar, ListItemText, Tooltip } from "@material-ui/core";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexGrow: 1,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  grow: {
    flexGrow: 1,
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  title: {
    flexGrow: 1,
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    height: "100vh",
    position: "fixed",
    zIndex: 1,
    [theme.breakpoints.up("sm")]: {
      position: "static",
    },
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: 0,
    [theme.breakpoints.up("sm")]: {
      width: 57,
    },
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    marginTop: 64,
    height: "calc(100vh - 64px)",
    overflow: "hidden",
  },
}));

export const MenuDrawer = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = React.useState(true);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const { children, exhibitorName, clientName, profileImage, navigate } = props;

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const goToBooth = () => {
    const { clientKey, exhibitorId, lang } = props;
    window.open(
      window.location.href.includes("localhost")
        ? `/booth/${exhibitorId.toString(36)}?clientkey=${clientKey}&lang=${lang}`
        : `/interaction/booth/${exhibitorId.toString(36)}?clientkey=${clientKey}&lang=${lang}`,
      "_blank"
    );
  };
  const goToMainRoom = () => {
    const { clientKey, eventCode, lang } = props;
    window.open(window.location.href.includes("localhost") ? `/digitalmeeting/${eventCode}?clientkey=${clientKey}` : `/interaction/digitalmeeting/${eventCode}?clientkey=${clientKey}`, "_blank");
  };
  const exportParticipantExcel = () => {
    Axios.get(`./api/InteractionReport/exhibitor/${props.exhibitorId}`, {
      responseType: "arraybuffer",
    }).then((response) => {
      var blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      var date = new Date();
      var datestr = `${date.getFullYear()}-${date.getMonth() < 10 ? "0" : ""}${date.getMonth()}-${date.getDate() < 10 ? "0" : ""}${date.getDate()}_${
        date.getHours() < 10 ? "0" : ""
      }${date.getHours()}${date.getMinutes() < 10 ? "0" : ""}${date.getMinutes()}`;

      var fileName = `${exhibitorName}_Besökare_${datestr}.xlsx`;
      fileSaver.saveAs(blob, fileName);
    });
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const mobileMenuId = "primary-search-account-menu-mobile";
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <PopMenuItem onClick={handleMenuClose}>Profile</PopMenuItem>
      <PopMenuItem onClick={handleMenuClose}>My account</PopMenuItem>
      <PopMenuItem onClick={handleMenuClose}>My account</PopMenuItem>
    </Menu>
  );

  const { page } = props;

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(classes.menuButton, {
              [classes.hide]: open,
            })}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap className={classes.title}>
            {exhibitorName}
          </Typography>
          <div className={classes.grow} />
          <div className={classes.sectionMobile}>
            <IconButton aria-label="account of current user" aria-controls="menu-appbar" aria-haspopup="true" color="inherit">
              <AccountCircleIcon />
            </IconButton>
            <IconButton aria-label="show more" aria-controls={mobileMenuId} aria-haspopup="true" onClick={handleMobileMenuOpen} color="inherit">
              <MoreVertIcon />
            </IconButton>
          </div>
          <div className={classes.sectionDesktop}>
            <IconButton aria-label="account of current user" aria-controls="menu-appbar" aria-haspopup="true" color="inherit" onClick={goToBooth}>
              <Tooltip title={<SystemLabel name="GoToBooth" />}>
                <StorefrontIcon />
              </Tooltip>
            </IconButton>
            <IconButton aria-label="account of current user" aria-controls="menu-appbar" aria-haspopup="true" color="inherit" onClick={exportParticipantExcel}>
              <Tooltip title={<SystemLabel name="DownloadStats" />}>
                <EqualizerIcon />
              </Tooltip>
            </IconButton>
            <IconButton aria-label="account of current user" aria-controls="menu-appbar" aria-haspopup="true" color="inherit" onClick={() => window.open("https://inadra.se/support")}>
              <Tooltip title={<SystemLabel name="Support" />}>
                <ContactSupportIcon />
              </Tooltip>
            </IconButton>

            <ListItem>
              <ListItemAvatar>
                <IconButton aria-label="account of current user" aria-controls="menu-appbar" aria-haspopup="true" color="inherit" onClick={() => navigate("SETTINGS.PROFILE")} style={{ padding: 0 }}>
                  {profileImage ? (
                    <Avatar style={{ border: "2px solid #eee" }} src={profileImage} />
                  ) : (
                    <Avatar style={{ border: "2px solid #eee" }}>
                      <AccountCircleIcon />
                    </Avatar>
                  )}
                </IconButton>
              </ListItemAvatar>
              <ListItemText primary={clientName} />
            </ListItem>
          </div>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        <div className={classes.toolbar}>
          <IconButton onClick={handleDrawerClose}>{theme.direction === "rtl" ? <ChevronRightIcon /> : <ChevronLeftIcon />}</IconButton>
        </div>
        <Divider />
        <List style={{ padding: 0 }}>
          {menuOptions.map((option, index) => (
            <div key={index}>
              <MenuItem {...combineProps([props, option, { handleDrawerOpen, open, page }])} />
            </div>
          ))}
        </List>
        <Divider />
      </Drawer>
      <main className={classes.content + " blueish-bg"}>{children}</main>
    </div>
  );
};
